export const ENTERPRISE_WORKSPACE_BASE = '/enterprise/workspace';
export const EMPLOYEE_WORKSPACE_BASE = '/work';

export type WorkspaceLeaf =
  | 'home'
  | 'timeline'
  | 'insights'
  | 'interventions'
  | 'observability'
  | 'check-in'
  | 'settings';

export function isEmployeeWorkspacePath(pathname: string): boolean {
  return pathname === EMPLOYEE_WORKSPACE_BASE || pathname.startsWith(`${EMPLOYEE_WORKSPACE_BASE}/`);
}

export function workspaceBaseForPath(pathname: string): string {
  return isEmployeeWorkspacePath(pathname) ? EMPLOYEE_WORKSPACE_BASE : ENTERPRISE_WORKSPACE_BASE;
}

export function workspacePath(baseOrPathname: string, leaf: WorkspaceLeaf): string {
  const base = baseOrPathname.startsWith('/') ? workspaceBaseForPath(baseOrPathname) : ENTERPRISE_WORKSPACE_BASE;
  return `${base}/${leaf}`;
}

export function workspacePathWithOrg(baseOrPathname: string, leaf: WorkspaceLeaf, orgId?: string | null): string {
  const path = workspacePath(baseOrPathname, leaf);
  const trimmed = typeof orgId === 'string' ? orgId.trim() : '';
  if (!trimmed) return path;
  return `${path}?org=${encodeURIComponent(trimmed)}`;
}
